import { Badge, TableCell } from "@pushpress/pushpress-ui";
import { PaymentHistoryItem } from "../../../../../apis/billingApi";

const getPaymentStatus = (status: PaymentHistoryItem["status"]) => {
  if (status === "success")
    return (
      <Badge size="sm" variant="success">
        Success
      </Badge>
    );
  if (status === "failure")
    return (
      <Badge size="sm" variant="error">
        Failed
      </Badge>
    );
  if (status === "pending")
    return (
      <Badge size="sm" variant="warning">
        Pending
      </Badge>
    );
  return (
    <Badge size="sm" variant="neutral">
      {status}
    </Badge>
  );
};

export const invoiceColumns = [
  {
    id: "openTimestamp",
    header: "Date Opened",
    cell: ({ row }) => <TableCell>{row.original.openTimestamp}</TableCell>,
  },
  {
    header: "Next Attempt",
    accessorKey: "nextAttemptTimestamp",
    cell: ({ row }) => (
      <TableCell>{row.original.nextAttemptTimestamp}</TableCell>
    ),
  },
  {
    id: "description",
    header: "Description",
    cell: ({ row }) => (
      <TableCell>Invoice {row.original.invoiceUuid}</TableCell>
    ),
  },
  {
    id: "type",
    accessorKey: "type",
    header: "Type",
    cell: () => (
      <TableCell>
        <Badge size="sm" variant="neutral">
          Invoice
        </Badge>
      </TableCell>
    ),
  },
  {
    header: "Payment",
    accessorKey: "billingType",
    cell: ({ row }) => <TableCell>{row.original.billingType}</TableCell>,
  },
  {
    header: "Amount",
    accessorKey: "total",
    cell: ({ row }) => <TableCell>{row.original.total}</TableCell>,
  },
  {
    header: "Status",
    accessorKey: "isPending",
    filterFn: (row, id, value) => {
      return value.includes(row.original.isPending);
    },
    cell: ({ row }) => (
      <TableCell className="tw-flex tw-justify-between">
        <Badge size="sm" variant="info">
          Open
        </Badge>
        {row.original.isPending && (
          <Badge size="sm" variant="warning">
            Pending
          </Badge>
        )}
      </TableCell>
    ),
  },
];

export const paymentColumns = [
  {
    id: "date",
    header: "Date",
    cell: ({ row }) => <TableCell>{row.original.date}</TableCell>,
  },
  {
    id: "description",
    header: "Description",
    cell: ({ row }) => (
      <TableCell className="tw-flex tw-flex-col tw-gap-1 tw-items-start">
        {row.original.description}
        {row.original.comped && (
          <Badge size="sm" variant="neutral">
            Payment was comped
          </Badge>
        )}
      </TableCell>
    ),
  },
  {
    id: "type",
    accessorKey: "type",
    header: "Type",
    cell: () => (
      <TableCell>
        <Badge size="sm">Payment</Badge>
      </TableCell>
    ),
  },
  {
    id: "amount",
    header: "Amount",
    cell: ({ row }) => <TableCell>{row.original.amount}</TableCell>,
  },
  {
    id: "status",
    header: "Status",
    cell: ({ row }) => getPaymentStatus(row.original.status),
  },
];
